export default function convertCentsToDollars(number: number, showDecimal = true): string {
  const decimalPoints = showDecimal ? 2 : 0;

  return parseFloat(`${Math.round(number) / 100}`).toFixed(decimalPoints);
}
